import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  Card, CardText, RaisedButton, DatePicker, MenuItem,
  TextField, SelectField
} from "material-ui";
import customDateTimeFormat from "../../../helpers/dateFormat";
import {
  OpenSolicitudEditarModificacion, CambiarInicioVigenciaArancel, CambiarMontoArancelPrestacion,
  CambiarTipoUnidad
} from "./actions";
import { GuardarSolicitudEditarModificacion } from "../GrillaSolicitud/actions";
import { ObtenerTiposUnidad, ObtenerTiposPrestaciones, ObtenerItemImed, ObtenerTipoProfesional } from "../../Global/actions";
import styles from "../../styles/styles";
import valorUnidad from "../../../helpers/valorUnidad";


class SolicitudEditarModificacion extends React.Component {
  componentWillMount() {
    this.props.dispatch(ObtenerTiposPrestaciones());
    this.props.dispatch(ObtenerTiposUnidad());
    this.props.dispatch(ObtenerItemImed());
    this.props.dispatch(ObtenerTipoProfesional());
  }

  CloseSolicitudEditarModificacion = () => {
    this.props.dispatch(OpenSolicitudEditarModificacion(false, null));
  }

  CambiarMontoArancelPrestacion = (event) => {
    const validacion = valorUnidad.Validar(event.target.value, this.props.detallePrestacion.tipoUnidad);
    this.props.dispatch(CambiarMontoArancelPrestacion(validacion.valor, validacion.error));
  }

  CambiarTipoUnidad = (event, index, value) => {
    const validacion = valorUnidad.Validar(this.props.detallePrestacion.montoArancelPrestacion, value);
    this.props.dispatch(CambiarTipoUnidad(value, validacion.error));
  }

  CambiarInicioVigenciaArancel = (event, date) => {
    /* const dateMin = new Date(Date.now());
    dateMin.setDate(dateMin.getDate() + 15);
    dateMin.setHours(0, 0, 0, 0);
    let dateMod = date;
    if (dateMin > date) {
      dateMod = dateMin;
      this.props.dispatch(CambiarInicioVigenciaArancel(
        dateMod,
        `La fecha no puede ser menor a ${dateMin.toLocaleDateString()}`
      ));
    } else { */
    this.props.dispatch(CambiarInicioVigenciaArancel(date/* dateMod */));
    //}
  }

  GuardarSolicitudEditarModificacion = () => {
    this.props.CambiosSinGuardar(true);
    this.props.dispatch(GuardarSolicitudEditarModificacion(this.props.detallePrestacion));
    this.props.dispatch(OpenSolicitudEditarModificacion(false, null));
  }

  render() {
    const { REACT_APP_REAJUSTAR_ARANCEL_FECHA_VIGENCIA_MINIMA: fechaVigenciaPrestador } = this.props.ENV;
    let today = new Date();
    today.setDate(today.getDate() + fechaVigenciaPrestador);
    const minDate = today;

    const menuListUnidad = [];
    if (this.props.tiposUnidad) {
      this.props.tiposUnidad.forEach((uni) => {
        menuListUnidad.push(<MenuItem key={uni.Unidad} value={uni.Unidad} primaryText={uni.Descripcion} />);
      });
    }

    let glosaTipoProfesional = this.props.detallePrestacion.tipoProfesional;
    if (this.props.tiposProfesionales && this.props.tiposProfesionales.length > 0) {
      const tps = this.props.tiposProfesionales.filter((tp) => tp.Tipo === this.props.detallePrestacion.tipoProfesional);
      if (tps && tps.length > 0) { glosaTipoProfesional = tps[0].Descripcion; }
    }

    return (
      <div style={{ width: 990 }}>
        <div style={styles.frameContenidoGeneral}>
          <Card zDepth={0} style={{ paddingBottom: 0 }}>
            <CardText style={{ paddingBottom: 0 }}>
              <div className="row" style={{ paddingBottom: 0 }}>
                <div className="col-12" style={{ margin: 0, padding: 0 }}>
                  <div style={styles.h1}>Editar línea de detalle de solicitud
                  </div>
                  <div style={styles.h3}>Modificación
                  </div>
                </div>
              </div>
              <div className="row" style={{ paddingBottom: 0, marginTop: 15 }}>
                <div className="col-1" style={styles.tituloEditarLinea}>
                  Arancel:
                </div>
                <div className="col-1" style={styles.datoEditarLinea}>
                  {this.props.detallePrestacion.glosaTipoArancel}
                </div>
                <div className="col-2" style={styles.tituloEditarLinea}>
                  Centro de Atención:
                </div>
                <div className="col-1" style={styles.datoEditarLinea}>
                  {this.props.detallePrestacion.glosaCentroAtencion}
                </div>
                <div className="col-2" style={styles.tituloEditarLinea}>
                  Tipo Atención:
                </div>
                <div className="col-1" style={styles.datoEditarLinea}>
                  {this.props.detallePrestacion.tipoAtencion == "A" ? "AMBULATORIA" : "HOSPITALARIA"}
                </div>
              </div>
              {/* <div class="row">
              <div class="col-12" style={{padding:0}}>
              <Divider style={{marginTop:10, marginBottom:10}}/>
              </div>
            </div> */}
              <div className="row" style={{ paddingBottom: 0, marginTop: 15 }}>
                <div className="col-2">
                  <div style={styles.floatingClaseSelect2}>Valor</div>
                  <TextField
                    name="txt_sem_montoArancel"
                    id="txt_sem_montoArancel"
                    value={this.props.detallePrestacion.montoArancelPrestacion}
                    onChange={this.CambiarMontoArancelPrestacion}
                    underlineStyle={styles.underlineSelectField}
                    inputStyle={styles.h4}
                    style={styles.selectFieldNuevaPrestacionTablaInferior}
                    errorText={this.props.detallePrestacion.montoArancelError}
                    errorStyle={{ bottom: "-6px" }}
                  />
                </div>
                <div className="col-5">
                  <div style={styles.floatingClaseSelect2}>Unidad</div>
                  <SelectField
                    name="dd_sem_tipounidad"
                    id="dd_sem_tipounidad"
                    value={this.props.detallePrestacion.tipoUnidad}
                    onChange={this.CambiarTipoUnidad}
                    labelStyle={styles.h4}
                    underlineStyle={styles.underlineSelectField}
                    style={styles.selectFieldNuevaPrestacion}
                    iconStyle={styles.iconSelectField}
                    menuItemStyle={styles.menuItemStyleSelectField}
                    selectedMenuItemStyle={styles.selectedMenuItemSelectFiueld}
                  >{menuListUnidad}
                  </SelectField>
                </div>
              </div>
              <div className="row" style={{ paddingBottom: 0, marginTop: 15 }}>
                <div className="col-5" style={styles.colSelectFieldActualizar}>
                  <div className="row">
                    <div className="col-6" style={styles.tituloModificarPrestacion}>
                      Código Prestación Prestador
                    </div>
                    <div className="col-6" style={styles.datoModificarPrestacion}>
                      {this.props.detallePrestacion.codigoPrestacionPrestador}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6" style={styles.tituloModificarPrestacion}>
                      Glosa Prestación Prestador
                    </div>
                    <div className="col-6" style={styles.datoModificarPrestacion}>
                      {this.props.detallePrestacion.glosaPrestacionPrestador}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6" style={styles.tituloModificarPrestacion}>
                      Código Fonasa Informado Prestador
                    </div>
                    <div className="col-6" style={styles.datoModificarPrestacion}>
                      {this.props.detallePrestacion.codigoFonasa}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6" style={styles.tituloModificarPrestacion}>
                      Tipo de Prestación
                    </div>
                    <div className="col-6" style={styles.datoModificarPrestacion}>
                      {this.props.detallePrestacion.glosaGrupoPrestador}
                    </div>
                  </div>
                </div>
                <div className="col-5" style={styles.colSelectFieldActualizar}>
                  <div className="row">
                    <div className="col-6" style={styles.tituloModificarPrestacion}>
                      Item IMED
                    </div>
                    <div className="col-6" style={styles.datoModificarPrestacion}>
                      {this.props.detallePrestacion.itemImed}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6" style={styles.tituloModificarPrestacion}>
                      Tipo de Profesional
                    </div>
                    <div className="col-6" style={styles.datoModificarPrestacion}>
                      {glosaTipoProfesional}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6" style={styles.tituloModificarPrestacion}>
                      Fin Vigencia Prestación
                    </div>
                    <div className="col-6" style={styles.datoModificarPrestacion}>
                      <DatePicker
                        name="dp_sem_inicioVigencia"
                        id="dp_sem_inicioVigencia"
                        mode="landscape"
                        minDate={minDate}
                        DateTimeFormat={customDateTimeFormat.cl()}
                        locale="es-CL"
                        firstDayOfWeek={1}
                        value={this.props.detallePrestacion.inicioVigenciaArancel}
                        errorText={this.props.detallePrestacion.inicioVigenciaArancelError}
                        onChange={this.CambiarInicioVigenciaArancel}
                        underlineStyle={styles.underlineSelectField}
                        style={styles.datepickerStyle}
                        inputStyle={styles.h4}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row" style={{ marginTop: 10, marginBottom: 10 }}>
                <div className="col-12" style={{ textAlign: "right" }}>
                  <RaisedButton
                    label="Cancelar"
                    onClick={this.CloseSolicitudEditarModificacion}
                    backgroundColor="#fff"
                    overlayStyle={{ borderRadius: 5 }}
                    labelStyle={{
                      fontSize: "11px", color: "#757575", paddingLeft: 10, paddingRight: 5,
                    }}
                    style={{ width: "145px", borderRadius: 5 }}
                    buttonStyle={{ border: "2px solid #C3C3C3", borderRadius: 5 }}
                  />
                  <RaisedButton
                    label="Guardar"
                    onClick={this.GuardarSolicitudEditarModificacion}
                    secondary
                    labelStyle={{ fontSize: "11px" }}
                    overlayStyle={{ borderRadius: 5 }}
                    rippleStyle={{ borderRadius: 5 }}
                    style={{ width: "130px", borderRadius: 5, marginLeft: 20 }}
                    buttonStyle={{ borderRadius: 5 }}
                    disabled={!!this.props.detallePrestacion.montoArancelError}
                  />
                </div>
              </div>
            </CardText>
          </Card>
        </div>
      </div>
    );
  }
}


SolicitudEditarModificacion.propTypes = {
  tiposUnidad: PropTypes.array.isRequired,
  tiposProfesionales: PropTypes.array.isRequired,
  detallePrestacion: PropTypes.any.isRequired,
  dispatch: PropTypes.func.isRequired,
  CambiosSinGuardar: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  tiposUnidad: state.global.tiposUnidad,
  tiposProfesionales: state.global.tiposProfesionales,
  detallePrestacion: {
    glosaTipoArancel: state.solicitudEditarModificacion.detallePrestacion.glosaTipoArancel,
    tipoAtencion: state.solicitudEditarModificacion.detallePrestacion.tipoAtencion,
    glosaCentroAtencion: state.solicitudEditarModificacion.detallePrestacion.glosaCentroAtencion,
    rowGuid: state.solicitudEditarModificacion.detallePrestacion.rowGuid,
    montoArancelError: state.solicitudEditarModificacion.detallePrestacion.montoArancelError,
    montoArancelPrestacion: state.solicitudEditarModificacion.detallePrestacion.montoArancelPrestacion,
    tipoUnidad: state.solicitudEditarModificacion.detallePrestacion.tipoUnidad,
    codigoPrestacionPrestador: state.solicitudEditarModificacion.detallePrestacion.codigoPrestacionPrestador,
    pabellonPrestacion: state.solicitudEditarModificacion.detallePrestacion.pabellonPrestacion,
    glosaPrestacionPrestador: state.solicitudEditarModificacion.detallePrestacion.glosaPrestacionPrestador,
    codigoFonasa: state.solicitudEditarModificacion.detallePrestacion.codigoFonasa,
    itemImed: state.solicitudEditarModificacion.detallePrestacion.itemImed,
    tipoProfesional: state.solicitudEditarModificacion.detallePrestacion.tipoProfesional,
    inicioVigenciaArancel: state.solicitudEditarModificacion.detallePrestacion.inicioVigenciaArancel,
    inicioVigenciaArancelError: state.solicitudEditarModificacion.detallePrestacion.inicioVigenciaArancelError,
    tipoPrestacion: state.solicitudEditarModificacion.detallePrestacion.tipoPrestacion,
    glosaGrupoPrestador: state.solicitudEditarModificacion.detallePrestacion.glosaGrupoPrestador,
  },
  ENV: state.global.ENV,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(SolicitudEditarModificacion);
